import { PRINTINVOICES } from "../../thirdParty/GalleryInvoicePrint";

export const handlePrintJournalEntries = (
  entries,
  transactionDetails,
  t,
  isRTL,
  business
) => {
  // Calculate totals
  const totalDebit = entries.reduce((sum, entry) => {
    return (
      sum +
      (entry.entry_type?.toLowerCase() === "debit"
        ? Number(entry.amount || 0)
        : 0)
    );
  }, 0);

  const totalCredit = entries.reduce((sum, entry) => {
    return (
      sum +
      (entry.entry_type?.toLowerCase() === "credit"
        ? Number(entry.amount || 0)
        : 0)
    );
  }, 0);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`; // DD-MM-YYYY
  };

  const content = `
    <!DOCTYPE html>
   <html lang="${isRTL ? "ar" : "en"}" dir="${isRTL ? "rtl" : "ltr"}">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Journal Entries</title>
      <style>
        @media print {
          @page { margin: 5mm; }
        }
        body {
          font-family: ${isRTL ? "'Tahoma', Arial, sans-serif" : "'Arial', Times, serif"};
          direction: ${isRTL ? "rtl" : "ltr"};
          text-align: ${isRTL ? "right" : "left"};
          font-size: 12px;
          margin: 20px 0;
          color: #000;
          -webkit-print-color-adjust: exact; /* Ensure background colors are printed */
          print-color-adjust: exact;
        }
        .header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 10px; }
        .header-left { width: 25%; }
        .header-center { width: 50%; text-align: center; display: flex; flex-direction: column; align-items: center; }
        .header-right { width: 25%; text-align: end; font-weight: bold; }
        
        .company-name { 
          font-size: 16px; 
          font-weight: 700; 
          padding: 0 10px; 
          margin-bottom: 5px; 
          display: inline-block;
        }
        .report-title { 
          font-size: 14px; 
          font-weight: semi-bold;  
          border-bottom: 1px solid #aaa;
          padding: 0 10px;
          padding-bottom: 4px;
          width: 200px;
          display: inline-block;
        }
        
        .info-grid {
            display: grid;
              grid-template-columns: repeat(3, 1fr);
  direction: ${isRTL ? "rtl" : "ltr"};
            gap: 10px;
            margin-top: 20px;
            margin-bottom: 10px;
            font-weight: bold;
        }
        
        .info-left { text-align: start; }
        .info-center { text-align: center; }
        .info-right { text-align: end; }

        .posting-box {
            display: inline-block;
            width: 12px;
            height: 12px;
            border: 1px solid #000;
            margin-left: 5px;
            vertical-align: middle;
        }

        .label { margin-right: 5px; }

        table { width: 100%; border-collapse: collapse; }
        .text-right {  text-align: end; }
        
        
        .totals-container {
            margin-top: 10px;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            gap: 5px;
        }
        
        .totals-row {
            display: flex;
            justify-content: space-between;
            min-width: 200px;
            padding: 5px 10px;
            font-weight: bold;
            // border-top: 1px solid #000;
        }
        
        .totals-row:last-child {
            border-bottom: 2px solid #000;
        }

      </style>
    </head>
    <body>
      <div class="header">
        <div class="header-left">
           <!-- Logo Placeholder -->
        </div>
        <div class="header-center">
          <div class="company-name">${`${business?.name_en}`}</div>
          <div class="report-title">${t("journal_entries")}</div>
        </div>
        <div class="header-right">
          <div><span class="label">${t("date")} :</span> ${new Date().toLocaleDateString("en-GB").replace(/\//g, "-")}</div>
          <div><span class="label">${t("page")} :</span> Page 1 of 1</div>
        </div>
      </div>

      <div class="info-grid">
        <div class="info-left">
            <div><span class="label">${t("record_no")}</span> : ${transactionDetails?.journal_entry_number || ""}</div>
            <div style="margin-top: 5px;"><span class="label">${t("description")}</span> : ${transactionDetails?.description || ""}</div>
        </div>
        <div class="info-center">
            <div><span class="label">${t("posting")}</span> : <span class="posting-box"></span></div>
        </div>
        <div class="info-right">
            <div>
                <span class="label">${t("date")}</span> : ${transactionDetails?.date ? formatDate(transactionDetails.date) : ""}
            </div>
            <div style="margin-top: 5px;">
                <span class="label">${t("period")}</span> : ${transactionDetails?.period || (transactionDetails?.updated_at ? new Date(transactionDetails.updated_at).toLocaleDateString("en-US", { month: "2-digit", year: "numeric" }).replace("/", " - ") : "")}
            </div>
        </div>
      </div>

      <div style="border: 1px solid #d1d5db; border-radius: 4px; overflow: hidden; margin-top: 5px;">
        <table style="width: 100%; border-collapse: collapse; font-size: 11px;">
          <thead>
            <tr style="background-color: #d1d5db; color: #111827; font-weight: 600;">
              <th style="padding: 8px; border-right: 1px solid #9ca3af; text-align: start; width: 12%;">${t("account_code")}</th>
              <th style="padding: 8px; border-right: 1px solid #9ca3af; text-align: start; width: 38%;">${t("account_name")}</th>
              <th style="padding: 8px; border-right: 1px solid #9ca3af; text-align: start; width: 26%;">${t("description")}</th>
              <th style="padding: 8px; border-right: 1px solid #9ca3af; text-align: right; width: 12%;">${t("debit")}</th>
              <th style="padding: 8px; text-align: right; width: 12%;">${t("credit")}</th>
            </tr>
          </thead>
          <tbody>
            ${entries
      .map((entry, index) => {
        const isDebit = entry.entry_type?.toLowerCase() === "debit";
        const debitAmount = isDebit
          ? Number(entry.amount).toFixed(2)
          : "0.00";
        const creditAmount = !isDebit
          ? Number(entry.amount).toFixed(2)
          : "0.00";

        return `
              <tr style="background-color: #ffffff; border-bottom: 1px solid #d1d5db;">
                 <td style="padding: 8px; border-right: 1px solid #d1d5db; text-align: start;">${entry.account_code || ""}</td>
                 <td style="padding: 8px; border-right: 1px solid #d1d5db; text-align: start;">${entry.account_name_en || ""}</td>
                 <td style="padding: 8px; border-right: 1px solid #d1d5db; text-align: start;">${entry.description || ""}</td>
                 <td style="padding: 8px; border-right: 1px solid #d1d5db; text-align: right;">${debitAmount}</td>
                 <td style="padding: 8px; text-align: right;">${creditAmount}</td>
              </tr>
            `;
      })
      .join("")}
          </tbody>
        </table>
      </div>
      
      <div class="totals-container">
        <div class="totals-row">
          <span>${t("total_debit")}:</span>
          <span>${totalDebit.toFixed(2)} ${t("SAR")}</span>
        </div>
        <div class="totals-row">
          <span>${t("total_credit")}:</span>
          <span>${totalCredit.toFixed(2)}  ${t("SAR")}</span>
        </div>
      </div>
    </body>
    </html>
  `;
  PRINTINVOICES(content);
};
